import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { Accordion } from '../Common/Accordion/Accordion';
import { base_url } from '../../Utils/baseUrl';
import { stripHtml } from '../../Utils/html';
import Seo from '../../Seo/Seo';
import { webPageSchema, faqPageSchema } from '../../Seo/jsonld';
import { getRouteSeo } from '../../Seo/routeSeo';
import { useTranslation } from 'react-i18next';

export const Faq = () => {
  // Fetching lives here rather than inside <Accordion /> so the FAQPage
  // structured data below is built from the exact same questions and answers
  // that get rendered.
  const [faqData, setFaqData] = useState([]);
  const pageNumber = 1;
  const pageSize = 4;

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    axios.get(`${base_url}faqs/active?pageNumber=${pageNumber}&pageSize=${pageSize}`)
      .then((response) => {
        setFaqData(response.data.data || []);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []);

  const seo = getRouteSeo("/faq");

  const { t } = useTranslation();

  return (
    <>
      <Seo
        jsonLd={[
          webPageSchema({
            title: seo?.title,
            description: seo?.description,
            url: "/faq",
          }),
          faqPageSchema(
            faqData.map((item) => ({
              question: stripHtml(item.question),
              answer: stripHtml(item.answer),
            }))
          ),
        ]}
      />
      <section className="page-info-sec">
        <div className="bg-fixed wow fadeIn" data-wow-delay="0.1s" style={{ background: 'url("/assets/img/page-info1.png")' }} />
        <div className="bg-fixed img-overlay wow fadeIn" data-wow-delay="0.2s" />
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-12">
              <div className="page-info-block wow fadeInUp" data-wow-delay="0.3s">
                <h1>FAQ</h1>
                <div className="btm-line-2 text-center justify-content-center">
                  <span />
                  <span />
                </div>
                <p>{t("common.FaqHeroSubtitle")}
                </p></div>
            </div>
          </div>
        </div>
      </section>
      <section className="sec-pd rel-z-1">
        <div className="top-bottom-shaps">
          <span className="shap shap-1" />
          <span className="shap shap-2" />
        </div>
        <div className="container">
          <div className="title-1 title-center wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="title-1-h">Ofte Stillede Spørgsmål</h2>
            <div className="btm-line-1 text-center justify-content-center">
              <span />
              <span />
            </div>
          </div>
          <Accordion items={faqData} />
        </div>
      </section>
    </>
  );
}
